<template>
    <div>
        <loading-custom :loading="loading" />

        <div class="card mb-0">
            <div class="tw-grid md:tw-grid-cols-3 tw-gap-6">
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Flash Sale
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            ตั้งค่าวันและเวลาในการจัดโปรโมชั่น Flash Sale
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex ">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="card border mb-0">
                            <div class="card-body card-body-flashsale">
                                <label>วัน-เวลาที่เริ่มต้น</label>
                                <div class="md:tw-flex">
                                    <div class="md:tw-mr-1.5 mb-3 md:mb-0">
                                        <date-picker
                                            v-model="form.start_date"
                                            type="date"
                                            placeholder="เลือกวันที่"
                                            format="YYYY-MM-DD"
                                            value-format="YYYY-MM-DD"
                                            valueType
                                        >
                                        </date-picker>
                                    </div>
                                    <div class="">
                                        <vue-timepicker
                                            input-class="time-input-custom"
                                            v-model="form.start_time"
                                            type="time"
                                            format="HH:mm:ss"
                                            placeholder="เลือกเวลา"
                                        >
                                        </vue-timepicker>
                                    </div>
                                </div>
                                <label class="mt-3">วัน-เวลาที่สิ้นสุด</label>
                                <div class="md:tw-flex">
                                    <div class="md:tw-mr-1.5 mb-3 md:mb-0">
                                        <date-picker
                                            v-model="form.end_date"
                                            type="date"
                                            placeholder="เลือกวันที่"
                                            format="YYYY-MM-DD"
                                            value-format="YYYY-MM-DD"
                                            valueType
                                        >
                                        </date-picker>
                                    </div>
                                    <div class="md:tw-mr-1.5">
                                        <vue-timepicker
                                            input-class="time-input-custom"
                                            v-model="form.end_time"
                                            type="time"
                                            format="HH:mm:ss"
                                            placeholder="เลือกเวลา"
                                        >
                                        </vue-timepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <div class="col-lg-12 p-0">
                                    <div class="d-flex flex-row-reverse">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-success"
                                            @click="store">
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <div class="card mb-0">
            <div class="tw-grid md:tw-grid-cols-3 tw-gap-6">
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Get Button
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            Facebook, Line, Tel.
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex ">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="card border mb-0">
                            <div class="card-body card-body-flashsale">
                                <div class="tw-grid grid-cols-1 md:tw-grid-cols-5">
                                    <div class="tw-col-span-1">
                                        <label>Facebook</label>
                                    </div>
                                    <div class="md:tw-col-span-4">
                                        <input 
                                            v-model="formButton.facebook"
                                            type="text" 
                                            name="facebook" 
                                            id="facebook" 
                                            class="w-100 button-input-custom">
                                    </div>
                                </div>
                                <div class="tw-grid grid-cols-1 md:tw-grid-cols-5">
                                    <div class="tw-col-span-1">
                                        <label>Line OA</label>
                                    </div>
                                    <div class="md:tw-col-span-4">
                                        <input 
                                            v-model="formButton.line_oa" 
                                            type="text" 
                                            name="line" 
                                            id="line" 
                                            class="w-100 button-input-custom">
                                    </div>
                                </div>
                                <div class="tw-grid grid-cols-1 md:tw-grid-cols-5">
                                    <div class="tw-col-span-1">
                                        <label>Tel.</label>
                                    </div>
                                    <div class="md:tw-col-span-4">
                                        <input 
                                            v-model="formButton.tel" 
                                            type="text" 
                                            name="tel" 
                                            id="tel" 
                                            class="w-100 button-input-custom">
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <div class="col-lg-12 p-0">
                                    <div class="d-flex flex-row-reverse">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-success"
                                            @click="storeButton">
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
    props: ["shop", "salePage", "button"],
    components: {
        VueTimepicker,
        DatePicker
    },
    data() {
        return {
            loading: false,
            form: {
                start_date: moment(this.salePage?.date_from).format("YYYY-MM-DD") || "",
                start_time: moment(this.salePage?.date_from).format("HH:mm:ss") || "",
                end_date: moment(this.salePage?.date_to).format("YYYY-MM-DD") || "",
                end_time: moment(this.salePage?.date_to).format("HH:mm:ss") || ""
            },

            formButton: {
                facebook: this.button?.facebook,
                line_oa: this.button?.line_oa,
                tel: this.button?.tel
            }
        };
    },
    methods: {
        store() {
            this.$swal({
                icon: "warning",
                title: "ต้องการบันทึก Flash sale ใช่ไหม?",
                text: "เมื่อกดยืนยัน Flash sale จะถูกบันทึก",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.loading = true;
                    this.form.start_date = moment(this.form.start_date).format("DD-MM-YYYY");
                    this.form.end_date = moment(this.form.end_date).format("DD-MM-YYYY");
                    axios
                        .post(
                            `/backend/s/${this.shop}/salepages/${this.salePage.id}/flash-sale`,
                            this.form
                        )
                        .then(res => {
                            this.loading = false;
                        })
                        .catch(err => {});
                } else if (result.isDenied) {
                    this.loading = false;
                }
            });
        },

        storeButton() {
            this.$swal({
                icon: "warning",
                title: "ต้องการบันทึก Button ใช่ไหม?",
                text: "เมื่อกดยืนยัน Button จะถูกบันทึก",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.loading = true;
                    axios
                        .post(
                            `/backend/s/${this.shop}/salepages/${this.salePage.id}/button`,
                            this.formButton
                        )
                        .then(res => {
                            this.loading = false;
                        })
                        .catch(err => {});
                } else if (result.isDenied) {
                    this.loading = false;
                }
            });
        }
    }
};
</script>


<style>
    .mx-input-wrapper {
        position: relative;
        max-width: 100%;
    }
    .vue__time-picker {
        width: 200px;
    }
    
    .time-input-custom {
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 210px !important;
        height: 34px !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc !important;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    }
    .vue__time-picker-dropdown,
    .vue__time-picker .dropdown {
        width: 210px !important;
    }
    .vue__time-picker-dropdown .select-list,
    .vue__time-picker .dropdown .select-list {
        width: 210px !important;
    }
    .button-input-custom {
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc !important;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    }
</style>